import {
  CampaignStateDefinition,
  GraphQLTypeNameData,
  GRAPHQL_TYPENAMES,
  MessageMedium,
  DraftStatus,
} from 'modules/graphql/types';
import { TemplateId } from 'modules/domains/template';
import { WorkflowType } from 'modules/workflows/enums';

type ListReferenceCommonData = {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
};

export enum ListReferenceSortableProperty {
  id = 'Id',
  name = 'Name',
  type = 'ListDependentType',
  updatedAt = 'UpdatedAt',
  createdAt = 'CreatedAt',
}

export enum ListReferenceType {
  Campaign = 'Campaign',
  Journey = 'Journey',
  List = 'List',
}

export type ListReferredByList = GraphQLTypeNameData<GRAPHQL_TYPENAMES.LIST> &
  ListReferenceCommonData & {
    creatorUserId: string;
  };

export type ListReferredByCampaign = GraphQLTypeNameData<GRAPHQL_TYPENAMES.CAMPAIGN> &
  ListReferenceCommonData & {
    createdBy: string;
    updatedBy: string | null;
    campaignState: CampaignStateDefinition;
    messageMedium: MessageMedium;
    templateId: TemplateId;
  };

export type ListReferredByJourney = GraphQLTypeNameData<GRAPHQL_TYPENAMES.JOURNEY> &
  ListReferenceCommonData & {
    creatorUserId: string;
    updatedByUserId: string | null;
    status: DraftStatus | null;
    enabled: boolean;
    isArchived: boolean;
    workflowType: WorkflowType;
  };

export type ListReference = ListReferredByList | ListReferredByCampaign | ListReferredByJourney;

export type ListReferenceUser = {
  id: string;
  fullName: string;
  avatarUrl?: string;
};

export type CreatorAndModifierById = Record<ListReferenceUser['id'], ListReferenceUser>;
